import createCustomApp from '../../utils/vue';
import MedicalInstitutionList from '../../components/MedicalInstitutionList.vue';

createCustomApp(MedicalInstitutionList).mount('[data-vue="list"]');
